import React, { FC, PropsWithChildren } from 'react';
import { Checkbox } from '@clearcover/atlas';
import { useAppContext, usePurchaseContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';
import agentConfirmationStyles from '../AgentConfirmation/styles.module.css';

interface SweepPaymentSetupProps extends PropsWithChildren {
  autopayEnabled: boolean;
  sweepAffirmationAccepted: boolean;
  onAutopayChange: (value: boolean) => void;
  onAffirmationChange: (value: boolean) => void;
  affirmationError?: string;
}

export const SweepPaymentSetup: FC<SweepPaymentSetupProps> = ({
  children,
  autopayEnabled,
  sweepAffirmationAccepted,
  onAutopayChange,
  onAffirmationChange,
  affirmationError,
}) => {
  const { agentSignatureAffirmation } = usePurchaseContext();
  const { rateLoading } = useAppContext();

  return (
    <div className={styles.container} data-testid="sweep-payment-setup">
      <h4 className={styles.heading}>Payment setup</h4>
      <div className={styles.toggleWrapper}>
        <Checkbox
          label=""
          data-testid="toggle-autopay-switch"
          name="autopayEnabled"
          toggle={true}
          value={autopayEnabled}
          onChange={onAutopayChange}
          disabled={rateLoading}
        />
        <p className={styles.toggleLabel}>
          Enroll customer in automatic payments
        </p>
      </div>
      <p className={styles.toggleSubtext}>
        Clearcover requires a payment method on file to enroll customer in
        automatic payments. Clearcover does not accept prepaid cards.
      </p>

      <div style={{ display: autopayEnabled ? undefined : 'none' }}>
        <hr className={styles.separator} />
        {children}
      </div>

      {autopayEnabled && agentSignatureAffirmation && (
        <>
          <div className={styles.affirmation} data-testid="sweep-affirmation">
            <Checkbox
              label={agentSignatureAffirmation.bodyTextSanitized.__html}
              name="sweepAffirmation"
              value={sweepAffirmationAccepted}
              onChange={onAffirmationChange}
              hideLabel
            />
            <label
              className={
                agentConfirmationStyles.agentConfirmationDisclosureCheckboxLabel
              }
              htmlFor={`sweepAffirmation_${sweepAffirmationAccepted}`}
              dangerouslySetInnerHTML={
                agentSignatureAffirmation.bodyTextSanitized
              }
            />
          </div>
          {affirmationError && (
            <p
              className={styles.affirmationError}
              data-testid="sweep-affirmation-error"
            >
              {affirmationError}
            </p>
          )}
        </>
      )}
    </div>
  );
};
